var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nav menu-item" },
    [
      _vm.contextMenuActive
        ? _c("ContextMenu", {
            ref: "contextMenu",
            attrs: { options: _vm.contextMenuOptions },
            on: { onClose: _vm.closeContextMenu }
          })
        : _vm._e(),
      _c(
        "a",
        {
          ref: "menuItemLink",
          class: _vm.currentClassList,
          attrs: {
            href: _vm.menuLink,
            "data-id": "menu-item-link",
            title: _vm.menuItem.itemText
          },
          on: {
            auxclick: _vm.handleAuxClick,
            click: _vm.handleClick,
            contextmenu: _vm.showContextMenu,
            blur: _vm.closeContextMenu
          }
        },
        [
          _c("span", { staticClass: "menu-item__link-icon" }, [
            _c("i", {
              class: ["icon", _vm.iconClass],
              attrs: { alt: _vm.menuItem.itemText }
            })
          ]),
          _c(
            "span",
            {
              staticClass: "menu-item__link-label",
              attrs: { "data-id": "menu-item-text" }
            },
            [_vm._v(" " + _vm._s(_vm.menuItem.itemText) + " ")]
          ),
          _vm.hasSubMenu
            ? _c("span", { staticClass: "menu-item__expand-icon" }, [
                _c("i", { staticClass: "icon icon-arrow_right_filled" })
              ])
            : _vm._e()
        ]
      ),
      _vm.menuItem.childItems
        ? _c(
            "Draggable",
            _vm._b(
              {
                ref: "subMenu",
                staticClass: "menu-item__sub-menu",
                class: _vm.isFavoritesParent && "is-favorite-parent",
                attrs: {
                  tag: "ul",
                  "data-id": "child-items",
                  disabled: !_vm.isFavoritesParent
                },
                on: { change: _vm.onItemsOrderChange },
                model: {
                  value: _vm.itemsInOrder,
                  callback: function($$v) {
                    _vm.itemsInOrder = $$v
                  },
                  expression: "itemsInOrder"
                }
              },
              "Draggable",
              _vm.dragOptions,
              false
            ),
            _vm._l(_vm.menuItem.childItems, function(childItem) {
              return _c(
                "li",
                { key: childItem.id, staticClass: "menu-item__sub-menu-item" },
                [
                  _c("VueMenuItem", {
                    attrs: {
                      menuItem: childItem,
                      topLevelParentId: _vm.topLevelParentId,
                      parentMenuIds: [..._vm.parentMenuIds, _vm.menuItem.id],
                      isMobile: _vm.isMobile,
                      companyId: _vm.companyId
                    },
                    on: { linkClick: _vm.onLinkClick }
                  })
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }